import React from 'react'
import PropTypes from 'prop-types'

const ArrowRight = ({ color = '#5A5C57', width = '24px', height = '24px' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Icons-/-Dark-Grey-/-Arrow-Right"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline
        id="Path-7"
        stroke={color}
        strokeWidth="2"
        points="12 19 19 11.9987793 12 5"
      ></polyline>
    </g>
  </svg>
)

ArrowRight.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
}

export default ArrowRight
